import React, {Component} from 'react';
import classNames from 'classnames';
import Style from './FJGifOption.module.less';
import InlineSVG from "react-inlinesvg";
import high from "../../../icon/high.png";
import gifWarn from "../../../icon/gif_warn.svg";
import customGif from "../../../icon/custom-gif.svg";
import gifArrow from "../../../icon/gif-arrow.svg";
import FJDropDown from "fj-components/FJDropDown"
import FJCustomScroll from "../../../common/component/FJCustomScroll";

const MEDIUM = 'MEDIUM';
const LOW = 'LOW';
const CUSTOM = 'CUSTOM';
const RESOLUTION = 'RESOLUTION';
const FPS = 'FPS';

class FJGifOption extends Component {

  constructor(props) {
    super(props);
    this.state = {
      type: LOW,
      resolutionIndex: 0,
      fpsIndex: 0
    }
  };

  _class = {
    HIGH: Style.high_box,
    MEDIUM: Style.medium_box,
    LOW: Style.low_box
  };

  _getCustomSize = () => {
    const {resolutionText, fpsText} = this.props;
    return [
      {
        type: RESOLUTION,
        label: resolutionText,
        list: [
          'Auto x 480',
          'Auto x 240',
          'Auto x 140',
          '800 x Auto',
          '500 x Auto',
          '320 x Auto'
        ],
        qualityList: [
          480,
          240,
          140,
          800,
          500,
          320
        ],
        listClassName: '',
      },
      {
        type: FPS,
        label: fpsText,
        list: [
          '15 fps',
          '10 fps',
          '5 fps',
        ],
        fpsList: [
          15,
          10,
          5
        ],
        listClassName: Style.fps,
      }
    ]
  };

  /**
   * @description 初始化
   */
  init = () => {
    this.setState({
      type: LOW,
      resolutionIndex: 0,
      fpsIndex: 0
    });
  };

  /**
   * @description 渲染输出GIF的尺寸选择
   * @returns {*[]}
   * @private
   */
  _getComp = () => {
    const {
      shouldAnimation,
      qualityTitle,
      qualityDesc,
      sizeTitle,
      sizeDesc,
      gifOptionPath,
      onRenderCheckIcon
    } = this.props;
    const {type} = this.state;
    const list = [
      {
        type: MEDIUM,
        name: qualityTitle,
        text: qualityDesc,
        url: `${gifOptionPath}export-gif-meduim.mp4`
      },
      {
        type: LOW,
        name: sizeTitle,
        text: sizeDesc,
        url: `${gifOptionPath}export-gif-low.mp4`
      }
    ];
    return list.map((item, index) => (
      <div className={classNames(Style.item_box,
        item.type === type ? Style.active : '',
        shouldAnimation ? Style['animation' + (index + 1)] : Style.no_animation)
      }
           key={item.type}
           onClick={() => {
             this._onClick(item.type)
           }}>
        <div className={Style.left}>
          <div className={classNames(this._class[item.type])}>
            <img src={high} className={Style.img} style={{opacity: item.type === type ? 0 : 1}}
                 alt=""/>
            <video src={item.url} loop autoPlay muted className={Style.video}
                   style={{opacity: item.type === type ? 1 : 0}}/>
          </div>
        </div>
        <div className={Style.right}>
          <div className={Style.desc_box}>
            <h4 className={Style.type}>{item.name}</h4>
            <div className={Style.desc}>{item.text}</div>
          </div>
        </div>
        <div className={Style.icon_box}>
          {item.type === type && onRenderCheckIcon()}
        </div>
      </div>
    ));
  };

  /**
   * @description 渲染
   * @returns {*}
   * @private
   */
  _getCustomComp = () => {
    const {
      shouldAnimation,
      customText,
      customResolutionText,
      fpsExplainText,
      onRenderQuestionIcon,
      onRenderCheckIcon
    } = this.props;
    const {type} = this.state;
    return (
      <div className={classNames(Style.item_box, {
        [Style.custom_item]: CUSTOM === type,
        [Style.active]: CUSTOM === type,
        [Style.animation3]: shouldAnimation,
        [Style.no_animation]: !shouldAnimation
      })}
           style={{marginBottom: '38px'}}
           onClick={() => {
             this._onClick(CUSTOM)
           }}
      >
        <div className={Style.left}>
          <InlineSVG src={customGif} element='div'/>
        </div>
        <div className={Style.right}>
          <div className={Style.desc_box}>
            <h4 className={Style.type}>{customText}</h4>
            <div className={Style.desc}>{customResolutionText}</div>
          </div>
          <div className={Style.auto}>
            {
              this._getCustomSize().map((item, index) => (
                <FJDropdownWithLabel key={item.type}
                                     label={item.label}
                                     text={item.type === FPS ? item.list[this.state.fpsIndex] : item.list[this.state.resolutionIndex]}
                                     list={item.list}
                                     listClassName={item.listClassName}
                                     onClick={(index) => {
                                       this._dropItemOnClick(item.type, index)
                                     }}
                                     marginRight={index === this._getCustomSize().length - 1 ? 0 : 50}
                />
              ))
            }

            <FJDropDown overlay={<div className={Style.question_drop}>{fpsExplainText}</div>}
                        placement='rightCenter'
                        ref={ele => this.limitOverlay = ele}
                        isTopLayer
                        trigger='hover'
            >
              <div className={Style.question_icon}>
                {onRenderQuestionIcon()}
              </div>
            </FJDropDown>
          </div>
        </div>
        {CUSTOM === type && onRenderCheckIcon()}
      </div>
    )
  };

  /**
   * @description 点击输出尺寸选择
   * @private
   */
  _onClick = (type) => {
    this.setState({
      type
    })
  };

  /**
   * @description 点击自定义尺寸输出
   * @param type
   * @param index
   * @private
   */
  _dropItemOnClick = (type, index) => {
    if (type === FPS) {
      this.setState({
        fpsIndex: index
      })
    } else if (type === RESOLUTION) {
      this.setState({
        resolutionIndex: index,
      })
    }
  };

  /**
   * @description 点击输出gif
   * @private
   */
  _export = () => {
    const {
      type,
      resolutionIndex,
      fpsIndex
    } = this.state;

    let customSize = this._getCustomSize();
    let size = {};
    let fps = 25;

    switch (type) {
      case MEDIUM:
        size.height = 480;
        fps = 15;
        break;
      case LOW:
        size.height = 240;
        fps = 10;
        break;
      case CUSTOM:
        if (resolutionIndex <= 2) {
          size.height = customSize[0].qualityList[resolutionIndex];
        } else {
          size.width = customSize[0].qualityList[resolutionIndex];
        }
        fps = customSize[1].fpsList[fpsIndex];
        break;
      default:
    }
    this.props.onExport(size, fps);
  };

  render() {
    const {isShow, disabled, title, shouldAnimation, exportText, limitTipText} = this.props;
    const {onRenderPrimaryButton} = this.props;
    return (
      <div className={classNames(Style.box, isShow ? Style.show : Style.hide)}>
        <div className={Style.resize_seat}/>
        <div className={Style.box_inner}>
          <h4 className={Style.title}>{title}</h4>
          {this._getComp()}
          {this._getCustomComp()}
          <div className={classNames(Style.btn_box, {
            [Style.btn_box_animation]: shouldAnimation,
            [Style.btn_box_no_animation]: !shouldAnimation
          })
          }>
            {
              onRenderPrimaryButton({
                className: Style.btn,
                size: 'middle',
                disabled,
                text: exportText,
                onClick: this._export,
              })
            }
          </div>
          {
            disabled ? <div className={Style.tips}>
              <InlineSVG src={gifWarn} element='div' className={Style.tip_icon}/>
              {limitTipText}
            </div> : null
          }
        </div>
      </div>
    );
  }
}


class FJDropdownWithLabel extends Component {

  render() {
    const {
      label,
      text,
      list,
      onClick,
      marginRight,
      listClassName,
    } = this.props;
    return (
      <div className={Style.select_box} style={{marginRight: `${marginRight}px`}}>
        <div className={Style.label}>{label}</div>
        <FJDropDown overlay={
          <div className={classNames(Style.size_list, listClassName)}>
            <FJCustomScroll>
              {
                list.map((item, index) => (
                  <div key={index}
                       onClick={() => {
                         onClick(index);
                         this._dropEle.hide();
                       }}
                       className={Style.size_item}>
                    {item}
                  </div>
                ))
              }
            </FJCustomScroll>
          </div>
        }
                    triggerDisplay='flex'
                    isTopLayer
                    ref={ele => this._dropEle = ele}
                    hasArrow={false}

        >
          <div className={Style.trigger}>
            <div className={Style.value}>{text}</div>
            <InlineSVG src={gifArrow} element='div'/>
          </div>
        </FJDropDown>
      </div>
    )
  }
}


export default FJGifOption
